/** Einen eingefügten Adresskopf in Felder zerlegen. */

import { useMutation } from '@tanstack/react-query'
import { api } from './klient'

export type Adresserkennung = {
  name: string | null
  funktion: string | null
  ansprechpartner: string | null
  strasse: string | null
  plz: string | null
  ort: string | null
  telefon: string | null
  email: string | null
  /** Zeilen ohne erkennbare Rolle – werden angezeigt, nicht verworfen. */
  rest: string[]
}

export function useAdresseErkennen() {
  return useMutation({
    mutationFn: (text: string) =>
      api.senden<Adresserkennung>('/api/adresse/erkennen', { text }),
  })
}
